export default __webpack_public_path__ + "62babeaacb4d79a7ff7c4d3628e2ce03.png";